import {
  SHOW_HOMESCREEN_MODAL,
  HIDE_HOMESCREEN_MODAL,
  SHOW_FAULTY_SENSOR_MODAL,
  HIDE_FAULTY_SENSOR_MODAL,
  IShowHomescreenModal,
  IHideHomescreenModal,
  IShowFaultySensorModal,
  IHideFaultySensorModal,
  SHOW_ADD_TARGET_MODAL,
  HIDE_ADD_TARGET_MODAL,
  IHideAddTargetModal,
  IShowAddTargetModal
} from "./types";

export const showHomescreenModal = (): IShowHomescreenModal => ({
  type: SHOW_HOMESCREEN_MODAL
});

export const hideHomescreenModal = (): IHideHomescreenModal => ({ type: HIDE_HOMESCREEN_MODAL });

export const showFaultySensorModal = (pressureChambers: number[]): IShowFaultySensorModal => ({
  type: SHOW_FAULTY_SENSOR_MODAL,
  payload: pressureChambers
});

export const hideFaultySensorModal = (): IHideFaultySensorModal => ({
  type: HIDE_FAULTY_SENSOR_MODAL
});

export const showAddTargetModal = (): IShowAddTargetModal => ({
  type: SHOW_ADD_TARGET_MODAL
});

export const hideAddTargetModal = (): IHideAddTargetModal => ({
  type: HIDE_ADD_TARGET_MODAL
});
